import CustomModal from "~components/CustomModal";
import { ErrorContent, ErrorModalProps } from "./ErrorModal";
import { Stack, Text } from "flicket-ui";
import AnimatedLoadingSpinner from "~features/single-page-checkout/components/AnimatedLoadingSpinner/AnimatedLoadingSpinner";
import { useRouter } from "next/router";

export const PrechargeSubmitModal = ({
  isOpen,
  error,
  onClose,
  orderId,
}: ErrorModalProps & {
  isOpen: boolean;
  orderId?: string;
}) => {
  const router = useRouter();

  const onAnimationComplete = () => {
    if (orderId) {
      setTimeout(() => {
        void router.push("/checkout/[orderId]", `/checkout/${orderId}`);
      }, 200);
    }
  };

  return (
    <CustomModal isOpen={isOpen} close={onClose}>
      {error && <ErrorContent error={error} onClose={onClose} />}
      {!error && (
        <Stack
          direction="vertical"
          gap={1}
          alignItems={"center"}
          justifyContent={"center"}
          height="386px"
        >
          <Text variant="header.M">Locking in your best price...</Text>
          <AnimatedLoadingSpinner
            loading={!orderId}
            onComplete={onAnimationComplete}
          />
        </Stack>
      )}
    </CustomModal>
  );
};
